import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowRight",
  "use": "arrowRight-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" fill=\"none\" id=\"arrowRight\"><defs><rect id=\"arrowRight_path_0\" x=\"0\" y=\"0\" width=\"36\" height=\"36\" /></defs><g opacity=\"1\" transform=\"translate(0 0)  rotate(0 18 18)\"><mask id=\"arrowRight_bg-mask-0\" fill=\"white\"><use xlink:href=\"#arrowRight_path_0\" /></mask><g mask=\"url(#arrowRight_bg-mask-0)\"><path id=\"arrowRight_路径 1\" fill-rule=\"evenodd\" style=\"fill:#1D7045\" transform=\"translate(4.5 15.000000011718761)  rotate(0 13.5 3.7499999941406243)\" opacity=\"1\" d=\"M0,0L0,2.85L20.4,2.85L17.55,5.7L19.35,7.5L24,2.85L27,0L23.4,0L0,0Z \" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrowRight.svg
// module id = /mtx
// module chunks = 21